<template>
  <v-dialog
    v-model="dialog"
    :max-width="maxWidth"
  >
    <template #activator="{ on, attrs }">
      <ActivatorButton
        v-if="buttonTitle"
        :parent-attrs="attrs"
        :parent-on="on"
        :icon-or-title="buttonTitle"
        :tooltip-text="title"
        :disabled="disabled"
        :style="{ display: visible ? 'flex' : 'none' }"
        @activate="onButtonActivate"
      />
    </template>
    <v-card>
      <v-card-title>Lookup ChemoTypes</v-card-title>

      <v-card-text>
        <b-form-select
          v-model="profile"
          title="ToxPrint profiles"
          :options="toxprintsProfiles"
          style="max-width: fit-content"
          class="mr-2"
          v-b-tooltip
          value-field="name"
          text-field="description"
        />
        <v-textarea
          v-model="idsText"
          :rows="5"
          autofocus
          placeholder="Please enter comma-, semicolon-, line- or space-separated ToxPrint IDs"
        />

        <v-container>
          <v-row>
            <v-col
              v-for="(l, i) in found"
              :key="i"
              class="pa-1"
            >
              <img
                :src="`${TOXPRINTS_URL}/render?id=${l.id}&profile=${profile}`"
                alt=""
                width="150"
                v-b-tooltip
              />
              <div style="margin-top: 1em">
                {{ l.label }}
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="dialog = false"
          aria-label="Close"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import DialogBase from '@/components/dialogs/DialogBase.vue'
import { TOXPRINTS_URL } from '@/main'
import { mapGetters } from 'vuex'
import ActivatorButton from '@/components/ActivatorButton.vue'

export default {
  components: { ActivatorButton },
  mixins: [DialogBase],

  props: {
    labels: {
      type: Object,
      default: () => {},
    },
  },

  data: () => ({
    idsText: null,
    found: [],
    profile: null,
  }),

  watch: {
    idsText() {
      const ids = this.idsText.split(/(,|;|\s+)/).filter((s) => !s.match(/^(,|;|\s*)$/))
      this.found = this._labels.filter((l) => ids.includes(l.label) || ids.includes((l.id + 1).toString()))
    },
  },

  computed: {
    TOXPRINTS_URL() {
      return TOXPRINTS_URL
    },
    _labels() {
      return this.labels[this.profile].map((l, i) => ({ id: i, label: l }))
    },
    ...mapGetters(['toxprintsProfiles', 'toxprintsDefaultProfile']),
  },

  mounted() {
    this.profile = this.toxprintsProfiles.find((p) => p.name === this.toxprintsDefaultProfile).name
  },
}
</script>
